import { translate } from "app/filters/i18nFilter";
import { FIND_LEADS_SEARCH_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import ErrorContentBase from "app/pages/sales-intelligence/pages/home/components/common/ErrorContentBase/ErrorContentBase";
import SavedSearchesCard from "app/pages/sales-intelligence/pages/home/components/SavedSearchesCard/SavedSearchesCard";
import RedirectButtonTracked from "app/pages/sales-intelligence/pages/home/containers/RedirectButton/RedirectButtonTracked";
import SavedSearchesCardContainer from "app/pages/sales-intelligence/pages/home/containers/SavedSearchesCardContainer/SavedSearchesCardContainer";
import type { ViewModelMetadata } from "app/pages/sales-intelligence/pages/home/types/models";
import { CardEventCategory } from "app/pages/sales-intelligence/services/tracking/home-page/types";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { withErrorBoundary } from "react-error-boundary";

const SavedSearchesCardWithErrorBoundary = withErrorBoundary(SavedSearchesCardContainer, {
    fallbackRender() {
        const metadata: ViewModelMetadata = {
            trackingCategory: CardEventCategory.SavedSearches,
            totalResultsCount: 0,
        };

        const handleClick = () => {
            proNavigator.go(FIND_LEADS_SEARCH_ROUTE);
        };

        return (
            <SavedSearchesCard metadata={metadata}>
                <ErrorContentBase
                    title={{ key: "si.pages.home.card.common.error.title" }}
                    subtitle={{ key: "si.pages.home.card.saved-searches.error.subtitle" }}
                >
                    <RedirectButtonTracked
                        metadata={metadata}
                        type="primary"
                        onClick={handleClick}
                    >
                        {translate("si.pages.home.card.saved-searches.action.my-saved-searches")}
                    </RedirectButtonTracked>
                </ErrorContentBase>
            </SavedSearchesCard>
        );
    },
});

export default SavedSearchesCardWithErrorBoundary;
